import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import { AlertTriangle, X } from 'lucide-react';
import './popup.css';
import ButtonLoading from '../buttonLoading/view';
import { dispatchCustomEvent, listener } from '../../../utils/dispatch';
import { lang } from '../../../utils/langs';

const ButtonConfirm = ({
    eventKey,
    msg = "¿Estás seguro de realizar esta acción?",
    onAcept = undefined,
    title = "",
    style = {},
    className = "confirm"
}) => {
    const [isVisible, setIsVisible] = useState(false);
    const [data, setData] = useState({});

    useEffect(() => {
        const unbind1 = listener('btn-notification-confirm-' + eventKey, (e) => {
            setIsVisible(true);
            setData(e.detail.data);
        });
        const unbind2 = listener('notification-confirm-' + eventKey, (e) => {
            setIsVisible(true);
            setData(e.detail.data);
        });
        return () => {
            if (unbind1) unbind1();
            if (unbind2) unbind2();
        };
    }, [eventKey]);

    const handleAcept = (e) => {
        dispatchCustomEvent(eventKey, data);
        setIsVisible(false);
        if (onAcept) onAcept(e);
    };

    const handleCancel = () => {
        setIsVisible(false);
        dispatchCustomEvent('loading-btn', {});
    };

    return (
        <>
            <ButtonLoading
                onClick={() => setIsVisible(true)}
                title={lang('es', title)}
                className={className}
                style={style}
            />
            {isVisible && ReactDOM.createPortal(
                <div className="confirm-overlay-backdrop" onClick={handleCancel}>
                    <div className="confirm-modal-card" onClick={(e) => e.stopPropagation()}>
                        <button type="button" className="confirm-modal-close" onClick={handleCancel}>
                            <X size={18} />
                        </button>
                        <div className="confirm-modal-header">
                            <div className="confirm-icon-wrapper danger">
                                <AlertTriangle size={26} />
                            </div>
                            <h3 className="confirm-modal-title">{title || "Confirmar acción"}</h3>
                        </div>
                        <p className="confirm-modal-message">{msg}</p>
                        <div className="confirm-modal-actions">
                            <button
                                type="button"
                                className="confirm-btn-cancel"
                                onClick={handleCancel}
                            >
                                {lang('es', 'cancelar') || 'Cancelar'}
                            </button>
                            <button
                                type="button"
                                className="confirm-btn-accept"
                                onClick={handleAcept}
                            >
                                {title && title.toLowerCase().includes('eliminar') ? 'Eliminar' : (lang('es', 'aceptar') || 'Aceptar')}
                            </button>
                        </div>
                    </div>
                </div>,
                document.body
            )}
        </>
    );
};

export default ButtonConfirm;
